import React from 'react'

const EditMeeting = () => {
  return (
    <div>
      edit meeting
    </div>
  )
}

export default EditMeeting
